import { useContext, useEffect, useState } from 'react'

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { useNavigate } from 'react-router-dom'
import { ButtonLarge } from 'src/components/ButtonLarge'
import DownloadIcon from '@mui/icons-material/Download'
import { Done } from '@mui/icons-material'

import backgroundLogo from '../../assets/images/background_logo.png'
import DataContext from 'src/contexts/DataContext'
import { composePath } from 'src/utils'
import * as S from './styles'
import { Modal } from 'src/components/Modal'
import { Button } from 'src/components/Button'
import { TCourses } from 'src/contexts/tools'
import { useCourseInfoHook } from 'src/hooks/useCourseInfoHook'

const InitialPage = () => {
  const navigate = useNavigate()

  const [courseLogo, setCourseLogo] = useState<string>('')

  const [isOpen, setIsOpen] = useState<boolean>(true)

  const { registration } = useContext(DataContext)

  const currentCourseInfo = useCourseInfoHook({ course: registration.course! })

  const handleDownload = () => {
    if (currentCourseInfo) {
      window.open(currentCourseInfo.manual_url)
    }
  }

  const oncloseModal = () => setIsOpen(false)

  const getDisclaimerByCourse = (course: TCourses | undefined) => {
    const disclaimers = {
      business: (
        <S.Typography>
          Este é o formulário de inscrição para a Germinare BUSINESS, escola
          técnica focada em formar jovens Tocadores de Negócios. As inscrições
          estão abertas somente para candidatos(as) devidamente matriculados(as)
          no <span>5º ano do Ensino Fundamental I.</span>
        </S.Typography>
      ),
      tech: (
        <S.Typography>
          Este é o formulário de inscrição para a Germinare TECH, escola técnica
          focada em formar jovens Desenvolvedores de Sistemas e Analistas de
          Dados. As inscrições estão abertas somente para candidatos(as)
          devidamente matriculados(as) no{' '}
          <span>9º ano do Ensino Fundamental II.</span>
        </S.Typography>
      ),
      'vet-lins': (
        <S.Typography>
          Este é o formulário de inscrição para a Germinare VET na cidade de{' '}
          <b>LINS</b>, escola de Ensino Médio com ênfase em liderança na área de
          produção. As inscrições estão abertas somente para candidatos(as)
          devidamente matriculados(as) no{' '}
          <span>9º ano do Ensino Fundamental II.</span>
        </S.Typography>
      ),
      'vet-amparo': (
        <S.Typography>
          Este é o formulário de inscrição para a Germinare VET na cidade de{' '}
          <b>AMPARO</b>, escola de Ensino Médio com ênfase em liderança na área
          de produção. As inscrições estão abertas somente para candidatos(as)
          devidamente matriculados(as) no{' '}
          <span>9º ano do Ensino Fundamental II.</span>
        </S.Typography>
      ),
      'ec43c13f-2dfa-48fb-b35b-0662bd7ad0be': (
        <S.Typography>
          Este é o formulário de inscrição para a Germinare BUSINESS - Teste,
          escola técnica focada em formar jovens Tocadores de Negócios. As
          inscrições estão abertas somente para candidatos(as) devidamente
          matriculados(as) no <span>5º ano do Ensino Fundamental I.</span>
        </S.Typography>
      ),
    }

    return course ? disclaimers[course] : <></>
  }

  useEffect(() => {
    currentCourseInfo && setCourseLogo(currentCourseInfo.logo_url)
  }, [currentCourseInfo])

  return (
    <S.ContainerFlex>
      <S.ContainerImage>
        <img src={backgroundLogo} alt="Imagem do logotipo da Germinare" />
      </S.ContainerImage>
      <S.Content>
        <S.Content>
          <S.Title>Bem-vindo(a)!</S.Title>

          {getDisclaimerByCourse(registration.course)}

          <S.ContainerImageLogo>
            <img src={courseLogo} alt="Imagem do logotipo da Germinare" />
          </S.ContainerImageLogo>
          <S.Info>Acesse o Manual do Candidato para mais informações.</S.Info>

          <S.DownloadButton onClick={() => handleDownload()}>
            <S.ButtonIcon>
              <DownloadIcon />
            </S.ButtonIcon>
            <S.Link>
              <span>Baixar manual do candidato</span>
            </S.Link>
          </S.DownloadButton>

          {['business', 'tech'].includes(registration.course!) && (
            <ButtonLarge
              variant={'contained'}
              onClick={() =>
                navigate(
                  composePath('/instrucoes', `admissao/${registration.course}`)
                )
              }
              endIcon={<ArrowForwardIosIcon />}
            >
              Iniciar Inscrição
            </ButtonLarge>
          )}

          {['vet-lins', 'vet-amparo'].includes(registration.course!) && (
            <ButtonLarge
              variant={'contained'}
              onClick={() =>
                navigate(
                  composePath('/documentos', `admissao/${registration.course}`)
                )
              }
              endIcon={<ArrowForwardIosIcon />}
            >
              Iniciar Inscrição
            </ButtonLarge>
          )}
          <br />
        </S.Content>
      </S.Content>

      <Modal
        open={isOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <S.ModalBox>
          <S.ModalTitle>
            Você está se candidatando para o curso{' '}
            {currentCourseInfo?.name?.toUpperCase()}
          </S.ModalTitle>

          <S.ModalDescription>
            {getDisclaimerByCourse(registration.course)}
          </S.ModalDescription>

          <S.ModalBoxButtons>
            <Button
              variant="contained"
              onClick={oncloseModal}
              endIcon={<Done />}
            >
              Confirmar
            </Button>
          </S.ModalBoxButtons>
        </S.ModalBox>
      </Modal>
    </S.ContainerFlex>
  )
}

export { InitialPage }
